import { FileText, CheckCircle2 } from 'lucide-react';
import { Label } from '@/components/ui/label';

const TemplateSelector = ({ templates, selectedTemplates, onToggle }) => {
  return (
    <div>
      <Label className="text-sm font-semibold text-gray-900 mb-3 flex items-center gap-2">
        Select Document Templates
        <span className="text-red-500">*</span>
      </Label>
      <p className="text-sm text-gray-500 mb-4">Choose one or more templates to generate</p>
      <div className="grid grid-cols-3 gap-3 max-h-80 overflow-y-auto p-1">
        {templates.map((template) => {
          const isSelected = selectedTemplates.includes(template.id);
          return (
            <button
              key={template.id}
              data-testid={`template-${template.id}`}
              onClick={() => onToggle(template.id)}
              className={`relative p-4 rounded-xl border-2 transition-all text-left ${
                isSelected
                  ? 'border-blue-500 bg-blue-50 shadow-sm'
                  : 'border-gray-200 hover:border-gray-300 hover:shadow-sm'
              }`}
            >
              <div className="flex items-start gap-3">
                <div className={`p-2 rounded-lg transition-colors ${isSelected ? 'bg-blue-500' : 'bg-gray-100'}`}>
                  <FileText className={`w-4 h-4 ${isSelected ? 'text-white' : 'text-gray-600'}`} />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="font-medium text-sm text-gray-900 line-clamp-2 mb-1">
                    {template.name}
                  </div>
                  <div className="text-xs text-gray-500">
                    {template.placeholders?.length || 0} fields
                  </div>
                </div>
              </div>
              {isSelected && (
                <div className="absolute top-2 right-2">
                  <CheckCircle2 className="w-5 h-5 text-blue-500" />
                </div>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default TemplateSelector;
